<template xmlns="http://www.w3.org/1999/html">
  <div>
    <h1 class="mb-8 mt-5 px-4 text-3xl font-bold">
      Поездка #{{ trip.id }}
    </h1>
    <flash-messages />
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex items-center py-2 px-4">
        <div>Маршрут</div>
        <div class="ml-auto">{{ trip.route.name}}</div>
      </div>
      <div class="flex items-center py-2 px-4">
        <div>Дата</div>
        <div class="ml-auto">{{ trip.trip_date }}</div>
      </div>
      <div class="flex items-center py-2 px-4">
        <div>Статус поездки</div>
        <div class="ml-auto">{{ trip.status_name}}</div>
      </div>
      <div class="flex items-center py-2 px-4">
        <div>Авто</div>
        <div class="ml-auto">{{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }} {{ trip.car.grn }}</div>
      </div>
      <div class="flex items-center py-2 px-4">
        <div>Стоимость</div>
        <div class="ml-auto">{{ trip.price }}р</div>
      </div>
      <div class="flex items-center py-2 px-4">
        <div>Мест доступно</div>
        <div class="ml-auto">
          <button v-if="trip.has_book_client" class="btn-indigo btn-sm" tabindex="-1" type="button" @click="releasePlace()">
            - резерв
          </button>
          <span class="ml-2 mr-2 xl font-bold">{{ trip.available_seats }}</span>
          <button v-if="trip.available_seats > 0" class="btn-indigo btn-sm" tabindex="-1" type="button" @click="bookPlace()">
            + резерв
          </button>
        </div>
      </div>
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
        <button class="btn-indigo" tabindex="-1" type="button" @click="returnBack">Вернуться</button>
        <loading-button v-if="trip.can_be_started" :loading="form.processing" class="btn-danger ml-auto" type="button" @click="start">Начать поездку</loading-button>
        <loading-button v-if="trip.can_be_finished" :loading="form.processing" class="btn-danger ml-auto" type="button" @click="finish">Завершить поездку</loading-button>
      </div>
    </div>
    <div class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
      <div class="px-2 py-6"><h1 class="text-center text-3xl font-bold">Клиенты</h1>
        <div class="mt-6 mx-auto border-b-2"></div>
        <div class="mt-5">
          <div v-for="client in trip.clients" :key="client.phone" class="px-2">
            <div class="flex items-center py-2 font-bold">
              <div class="mr-3">{{ client.name }}</div>
              <div class="ml-auto">{{ client.phone }}</div>
            </div>
            <div v-if="client.pin_code" class="flex items-center py-2">
              <div class="mr-3">Пин код Telegram</div>
              <div :id="'showPin' + client.id" class="ml-auto font-bold"><a v-on:click=showPin(client.id)>Показать</a></div>
              <div :id="'pinCode' + client.id" class="ml-auto font-bold hidden">{{ client.pin_code }}</div>
            </div>
            <div class="flex items-center py-2">
              <div>Количество мест</div>
              <div class="ml-auto">{{ client.seats }}</div>
            </div>
            <div class="flex items-center py-2">
              <div>Цена</div>
              <div class="ml-auto">
                <span v-if="client.price === client.final_price">{{ client.price }}р.</span>
                <span v-if="client.price !== client.final_price">
                  <span style="text-decoration: line-through; color: rgb(128,128,128)">{{ client.price }}</span>
                  <span style="font-weight: bold">{{ client.final_price }}р.</span>
                </span>
              </div>
            </div>
            <div v-if="client.paid" class="flex w-full items-center py-2">
              <div class="text-justify mx-auto">ОПЛАЧЕНО</div>
            </div>
            <div v-if="client.address" class="flex items-center py-2">
              <div class="mr-3">Адрес</div>
              <div class="ml-auto italic">{{ client.address }}</div>
            </div>
            <div v-if="client.point_id" class="flex items-center py-2">
              <div class="mr-3">Точка</div>
              <div class="ml-auto">{{ client.point_name }}</div>
            </div>
            <div v-if="client.point_time" class="flex items-center py-2">
              <div class="mr-3">Время подбора</div>
              <div class="ml-auto">{{ client.point_time }}</div>
            </div>
            <div class="flex items-center py-2">
              <div class="mr-3">Добавлен</div>
              <div class="ml-auto">{{ client.created_at }},  {{ client.added_by }}</div>
            </div>
            <div class="flex items-center py-2">
              <div class="ml-auto text-gray-600 italic">{{ client.comment }}</div>
            </div>
            <div v-if="client.client_status_id === 0" class="border-l">
              Статус: добавлен, подтверждение не запрошено.
              <button v-if="client.can_be_notified" class="btn-indigo btn-sm" tabindex="-1" type="button" @click="requestConfirm(client.id)">
                запросить подтверждение
              </button>
              <button v-if="!client.can_be_notified" class="btn-indigo btn-sm" tabindex="-1" type="button" @click="confirmClient(client.id)">
                не подключен к боту, подтвердить звонком
              </button>
            </div>
            <div v-if="client.client_status_id === 10" class="border-l" style="color: orange">
              Статус: подтверждение запрошено {{ client.status_at }} ({{ client.status_by}})
              <button class="btn-indigo btn-sm" tabindex="-1" type="button" @click="confirmClient(client.id)">
                подтвердить звонком
              </button>
            </div>
            <div v-if="client.client_status_id === 20" class="border-l" style="color: green">
              Статус: поездка подтверждена {{ client.status_at }} ({{ client.status_by}})
              <button class="btn-indigo btn-sm" tabindex="-1" type="button" @click="pickupClient(client.id)">
                забрал клиента
              </button>
            </div>
            <div v-if="client.client_status_id === 30" class="border-l" style="color: green">
              Статус: клиент на месте {{ client.status_at }} ({{ client.status_by}})
              <button class="btn-indigo btn-sm" tabindex="-1" type="button" @click="pickupClient(client.id)">
                забрал клиента
              </button>
            </div>
            <div v-if="client.client_status_id === 40" class="border-l" style="color: green">
              Статус: клиент в авто {{ client.status_at }} ({{ client.status_by}})
            </div>
            <div class="my-3 mx-auto w-24 border-b-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'
import {Link} from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
    FlashMessages,
    LoadingButton,
  },
  props: {
    trip: Object,
    points: Array,
    error: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        authData: authData ? authData : Telegram.WebApp.initData,
      }),
    }
  },
  methods: {
    showPin(id) {
      document.getElementById('showPin' + id).classList.add('hidden')
      document.getElementById('pinCode' + id).classList.remove('hidden')
    },
    finish() {
      this.form.post(`/webapp/driver/trip/finish/${this.trip.id}`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },
    start() {
      if(confirm('Начать поездку? Клиенты получат уведомления о том, что водитель начал поездку.')) {
        this.form.post(`/webapp/driver/trip/start/${this.trip.id}`, {
          authData: authData ? authData : Telegram.WebApp.initData,
        })
      }
    },
    requestConfirm(clientId) {
      this.$inertia.post(`/webapp/driver/trip/${this.trip.id}/client/${clientId}/request`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    confirmClient(clientId) {
      this.$inertia.post(`/webapp/driver/trip/${this.trip.id}/client/${clientId}/confirm`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    pickupClient(clientId) {
      this.$inertia.post(`/webapp/driver/trip/${this.trip.id}/client/${clientId}/pickup`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    bookPlace() {
      if(confirm('Зарезервировать место? Количество доступных для бронирования мест уменьшится на одно.')) {
        this.$inertia.post(`/webapp/driver/trip/${this.trip.id}/book-place`, {
          authData: authData ? authData : Telegram.WebApp.initData,
        })
      }
    },

    releasePlace() {
      if(confirm('Убрать резерв? Количество доступных для бронирования мест увеличится на одно. Клиенты из списка ожидания получат приглашения')) {
        this.$inertia.post(`/webapp/driver/trip/${this.trip.id}/release-place`, {
          authData: authData ? authData : Telegram.WebApp.initData,
        })
      }
    },

    returnBack() {
      this.$inertia.visit('/webapp/init', {
        method: 'post',
        data: {
          authData: authData ? authData : Telegram.WebApp.initData,
        },
      })
    },
  },
}
</script>
